module.exports = __webpack_public_path__ + "img/tertiary_11x3.dffa51c1.svg";